<template>
  <div>
    <div class="rechargepay" :class="value === true ? 'on' : ''">
      <div class="title acea-row row-center-wrapper">
        选择付款方式<span class="iconfont icon-guanbi" @click="close"></span>
      </div>
      <div class="confirm-nav acea-row row-center-wrapper">
        <div class="confirm-content">
          <div class="careful">请仔细核对账号</div>
          <div class="number">{{ account }}</div>
          <div class="no-refund">充值成功后不支持退款</div>
          <div class="confirm-pay">
            需要支付
            <span class="money font-color-red">{{ payPrice }}</span>
            <span class="integral">积分</span>
          </div>
        </div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="types.indexOf('weixin') !== -1"
        @click="checked('weixin')"
      >
        <div class="left acea-row row-between-wrapper">
          <div class="iconfont icon-weixinzhifu"></div>
          <div class="text">
            <div class="name">微信支付</div>
            <div class="info">使用微信快捷支付</div>
          </div>
        </div>
        <div class="iconfont icon-xiangyou"></div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="types.indexOf('unionpay') !== -1"
        @click="checked('unionpay')"
      >
        <div class="left acea-row row-between-wrapper">
          <div class="iconfont icon-yinlian"></div>
          <div class="text">
            <div class="name">银联支付</div>
            <div class="info">使用银联快捷支付</div>
          </div>
        </div>
        <div class="iconfont icon-xiangyou"></div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="types.indexOf('alipay') !== -1"
        @click="checked('alipay')"
      >
        <div class="left acea-row row-between-wrapper">
          <div class="iconfont icon-zhifubao"></div>
          <div class="text">
            <div class="name">支付宝支付</div>
            <div class="info">使用线上支付宝支付</div>
          </div>
        </div>
        <div class="iconfont icon-xiangyou"></div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="types.indexOf('yue') !== -1"
        @click="checked('yue')"
      >
        <div class="left acea-row row-between-wrapper">
          <div class="iconfont icon-yuezhifu"></div>
          <div class="text">
            <div class="name">余额支付</div>
            <div class="info">
              当前可用余额：<span class="money">{{ balance }}</span>
            </div>
          </div>
        </div>
        <div class="iconfont icon-xiangyou"></div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="types.indexOf('offline') !== -1"
        @click="checked('offline')"
      >
        <div class="left acea-row row-between-wrapper">
          <div class="iconfont icon-yuezhifu1"></div>
          <div class="text">
            <div class="name">线下支付</div>
            <div class="info">选择线下付款方式</div>
          </div>
        </div>
        <div class="iconfont icon-xiangyou"></div>
      </div>
    </div>
    <div class="mask" v-show="value" @click="close"></div>
  </div>
</template>
<script>
export default {
  name: "RechargePayment",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    account: {
      type: String,
      default: ""
    },
    payPrice: {
      type: [Number, String],
      default: 0
    },
    balance: {
      type: [Number, String],
      default: 0
    },
    types: {
      type: Array,
      default: () => ["weixin", "alipay", "yue", "offline"]
    }
  },
  data: function() {
    return {};
  },
  mounted: function() {},
  methods: {
    checked: function(type) {
      this.$emit("checked", type);
      this.close();
    },
    close: function() {
      this.$emit("input", false);
    }
  }
};
</script>
<style scoped>
.rechargepay {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  border-radius: 0.16rem 0.16rem 0 0;
  background-color: #fff;
  padding-bottom: 0.6rem;
  z-index: 99;
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -o-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  transform: translate3d(0, 100%, 0);
  -webkit-transform: translate3d(0, 100%, 0);
  -ms-transform: translate3d(0, 100%, 0);
  -moz-transform: translate3d(0, 100%, 0);
  -o-transform: translate3d(0, 100%, 0);
}

.rechargepay.on {
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
}

.rechargepay .title {
  text-align: center;
  height: 1.23rem;
  font-size: 0.32rem;
  color: #282828;
  font-weight: bold;
  padding-right: 0.3rem;
  margin-left: 0.3rem;
  position: relative;
  border-bottom: 0.01rem solid #eee;
}

.rechargepay .title .iconfont {
  position: absolute;
  right: 0.3rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.43rem;
  color: #8a8a8a;
  font-weight: normal;
}

.rechargepay .item {
  border-bottom: 0.01rem solid #eee;
  height: 1.3rem;
  margin-left: 0.3rem;
  padding-right: 0.3rem;
}

.rechargepay .item .left {
  width: 6.1rem;
}

.rechargepay .item .left .text {
  width: 5.4rem;
}

.rechargepay .item .left .text .name {
  font-size: 0.32rem;
  color: #282828;
}

.rechargepay .item .left .text .info {
  font-size: 0.24rem;
  color: #999;
}

.rechargepay .item .left .text .info .money {
  color: #ff9900;
}

.rechargepay .item .left .iconfont {
  font-size: 0.45rem;
}

.rechargepay .item .left .iconfont.icon-weixinzhifu {
  color: #22ac38;
}

.rechargepay .item .left .iconfont.icon-zhifubao {
  color: #1677ff;
}

.rechargepay .item .left .iconfont.icon-yuezhifu {
  color: #ff9900;
}

.rechargepay .item .left .iconfont.icon-yuezhifu1 {
  color: #eb6623;
}

.rechargepay .item .iconfont {
  font-size: 0.3rem;
  color: #999;
}

.rechargepay .confirm-nav {
  width: 100%;
  border-bottom: 0.01rem solid #eee;
}
.rechargepay .confirm-nav .confirm-content {
  width: 80%;
  margin: 0 auto;
  display: inline-block;
  text-align: center;
}
.rechargepay .confirm-nav .confirm-content .careful {
  margin: 0.1rem 0;
  font-size: 0.26rem;
}
.rechargepay .confirm-nav .confirm-content .number {
  margin: 0.2rem 0;
  font-size: 0.3rem;
  font-weight: 700;
}
.rechargepay .confirm-nav .confirm-content .no-refund {
  margin: 0.2rem 0;
  font-size: 0.26rem;
}
.rechargepay .confirm-nav .confirm-content .confirm-pay {
  margin: 0.2rem 0;
  font-size: 0.26rem;
}
.rechargepay .confirm-nav .confirm-content .confirm-pay .money {
  margin: 0 0.1rem;
  font-size: 0.3rem;
}
.rechargepay .confirm-nav .confirm-content .confirm-pay .integral {
  font-size: 0.26rem;
}
</style>
